import React, { useState } from 'react';
import { SimpleApp, AppKey } from '../../../../libs/apps';
import BPCheckbox from '../../../atoms/checkbox/bpcheckbox';
import Dialog from '../../../organisms/dialog';
import { Classes } from '@blueprintjs/core';
import Button from '../../../molecules/button';
import { Container, Row, Col } from '../../../../grid';
import { sortApps } from './utils';

interface SelectAppsProps {
  apps: Record<AppKey, SimpleApp>;
  selectedApps: SimpleApp[];
  update: any;
}

const SelectApps: React.FC<SelectAppsProps> = ({
  apps,
  selectedApps,
  update
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const appsArray = apps
    ? Object.values(apps)
        .filter((app) => app.key !== 'composer')
        .sort(sortApps)
    : [];
  const selectedAppKeys = selectedApps.map((app) => app.key);

  const toggleDialog = () => {
    setIsDialogOpen(!isDialogOpen);
  };

  const toggleSelected = (appKey: AppKey) => {
    let updated: string[];
    if (selectedAppKeys.includes(appKey)) {
      updated = selectedAppKeys.filter((key) => key !== appKey);
    } else {
      updated = selectedAppKeys.concat(appKey);
    }
    update('filters.apps', updated);
  };

  return (
    <React.Fragment>
      <Dialog
        title="Select Programs Filter"
        isOpen={isDialogOpen}
        onClose={toggleDialog}
      >
        <div className={Classes.DIALOG_BODY}>
          <p className="mb-8">
            If you do not want to filter against programs, do not select any.
          </p>
          <Container fluid>
            <Row>
              {appsArray.map(
                (app) =>
                  !app.deprecated && (
                    <Col key={app.key} md={8}>
                      <BPCheckbox
                        label={app.name}
                        checked={selectedAppKeys.includes(app.key)}
                        onClick={() => toggleSelected(app.key)}
                      />
                    </Col>
                  )
              )}
            </Row>
          </Container>
        </div>
      </Dialog>
      <Button variant="minimal" className="underline" onClick={toggleDialog}>
        + Show All Programs
      </Button>
    </React.Fragment>
  );
};

export default SelectApps;
